export default __webpack_public_path__ + "static/media/flag-israel.38e906cc.svg";